<template>
  <ac-modal :title="'Terminate Member'" :size-class="'modal-md'" ref="modalRef">
    <template>
      <form v-if="widgetReady">
        <div class="row">
          <div class="info-board info-board-blue">
            <div class="row" v-if="!isTerminated">
              <div class="col-lg-12">
                <p class="text-primary">
                  <small>
                    <em>
                      You are about to terminate {{ vm.firstName }} {{ vm.lastName }}.
                      Doing so will take effect immediately and disable
                      the member’s access to Accresa and its services.
                    </em>
                  </small>
                </p>
              </div>
              <div class="col-xs-12 col-lg-12">
                <div class="form-group">
                  <label>Termination Date</label><br/>
                  <ac-date-picker v-model="vm.effEndDate" :useTodayAsDefault="true"/>
                </div>
              </div>
            </div>
            <div class="row" v-if="isTerminated">
              <div class="col-lg-12">
                <p class="text-primary">
                  <small>
                    <em>
                      Employee has been terminated, effective date:
                      {{ vm.effEndDate | shortDate }}
                    </em>
                  </small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template slot="buttons">
      <ac-button type="button" class="btn btn-red btn-sm" :action="closeModal">CANCEL</ac-button>
      <ac-button class="btn btn-green btn-sm" :action="termEmployee">
        TERMINATE MEMBER
      </ac-button>
    </template>
  </ac-modal>
</template>

<script>
import {api} from "../../../global/framework/api.js";

export default {
  name: "TerminateEmployeeModal",
  data() {
    return {
      vm: {},
      widgetReady: false,
      isTerminated: false
    }
  },
  computed: {
    vmRef() {
      return this.$data;
    }
  },
  methods: {
    async showModal({companyId, consumerId}) {
      let data = await api.getDataWithTwoIds('Company', companyId, 'GetEditEmployeeInfoModel', consumerId);
      this.mapData('vm', data.consumer);
      this.isTerminated = Boolean(data.consumer.effEndDate);
      this.widgetReady = true;
      this.$refs.modalRef.open();
    },
    async termEmployee() {
      let result = await api.post("Company", "TermEmployee", {consumerId: this.vm.consumerId, effDate: this.vm.effEndDate});
      if (result) {
        this.closeModal();
        this.$bus.$emit(this.$AcEvents.EMPLOYEE_TERMINATED, result);
      }
    },
    closeModal() {
      this.$refs.modalRef.close();
    }
  }
}
</script>

<style scoped>

</style>